import { ReactNode } from "react";
import { ColumnMatcher } from "../../models/ColumnMatcher";
import { TableConfig } from "../../models/config/TableConfig";
import { TableModel } from "../../models/TableModel";
import "../../styles/tableEditing/columnEditorList.css";

export { ColumnEditorList };

type Props = {
  tableConfig: TableConfig;
  tableModel: TableModel;
  modelChanged: (tableModel: TableModel) => void;
  children: (
    columns: ColumnMatcher[],
    update: (matcher: ColumnMatcher) => void,
    changeAnchor: (matcher: ColumnMatcher) => void,
    changeAnchorDirection: (matcher: ColumnMatcher, reversed: boolean) => void,
  ) => ReactNode;
};

const ColumnEditorList = ({
  tableConfig,
  tableModel,
  modelChanged,
  children,
}: Props) => {
  const updateMatcher = (matcher: ColumnMatcher) => {
    tableModel.updateColumn(matcher);
    if (matcher.anchor && matcher.matcher.getDiscriminator() === "F_DEFAULT") {
      tableModel.anchorGone();
    }
    modelChanged(tableModel);
  };
  const changeAnchor = (matcher: ColumnMatcher) => {
    tableModel.changeAnchor(matcher.columnName);
    modelChanged(tableModel);
  };
  const changeAnchorDirection = (matcher: ColumnMatcher, reversed: boolean) => {
    tableModel.changeAnchorDirection(matcher.columnName, reversed);
    modelChanged(tableModel);
  };

  // FIXME: test columnConfig.hidden works
  /* Reverse column order so Column suggestions doesn't have z-index issues. see columnEditorList.css */
  const columnMatchers = tableConfig.columnNames
    .filter((c) => !c.actualHidden)
    .map((column) => tableModel.getColumn(column))
    .filter((c): c is ColumnMatcher => c != undefined)
    .reverse();

  const addChild = columnMatchers.length % 2 !== 0;
  return (
    <div className={"columnEditorList"}>
      {addChild && <div />}
      {children(
        columnMatchers,
        updateMatcher,
        changeAnchor,
        changeAnchorDirection,
      )}
    </div>
  );
};
